// source: no/jotta/openapi/error.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.no.jotta.openapi.ErrorType', null, global);
/**
 * @enum {number}
 */
proto.no.jotta.openapi.ErrorType = {
  UNKNOWN: 0,
  UNKNOWN_ERROR: 11,
  OK: 9,
  CANCELLED: 10,
  INVALID_ARGUMENT: 12,
  DEADLINE_EXCEEDED: 13,
  NOT_FOUND: 14,
  PERMISSION_DENIED: 16,
  UNAUTHORIZED: 4,
  RESOURCE_EXHAUSTED: 17,
  FAILED_PRECONDITION: 18,
  ABORTED: 19,
  OUT_OF_RANGE: 20,
  UNIMPLEMENTED: 21,
  INTERNAL: 22,
  UNAVAILABLE: 23,
  DATA_LOSS: 24,
  UNAUTHENTICATED: 3,
  ALREADY_EXISTS: 5,
  FILE_NOT_FOUND: 1,
  PATH_NOT_FOUND: 2,
  CONFLICT: 6,
  PRECONDITIONS_FAILED: 7,
  ACCOUNT_LOCKED: 8,
  INVALID_EMAIL: 25,
  EMAIL_IN_USE: 26,
  INVALID_PHONE_NUMBER: 27,
  PHONE_NUMBER_IN_USE: 28,
  FS_NOT_PREPARED: 29,
  FS_ALREADY_PREPARED: 30,
  INSUFFICIENT_CAPACITY: 31,
  READ_LOCKED: 32,
  WRITE_LOCKED: 33,
  TOO_MANY_DEVICES: 34,
  TOO_MANY_USERS: 35,
  QUOTA_FULL_WRITE_LOCKED: 36,
  BREACH_WRITE_LOCKED: 37,
  EXPIRED_READ_LOCKED: 38,
  EXPIRED_WRITE_LOCKED: 39,
  NEW_QUOTA_IS_LESS_THEN_USED_USER_CAPACITY: 40,
  NEW_QUOTA_IS_GREATER_THEN_BIZ_ACCOUNT: 41,
  NEW_QUOTA_IS_GRATER_THEN_BIZ_AVAILABLE: 42,
  ASSET_EXPIRED: 43,
  PAYMENT_FAILED: 44,
  PAYMENT_DECLINED: 45,
  FILE_ONTO_FILE: 46,
  FILE_ONTO_FOLDER: 47,
  FOLDER_ONTO_FILE: 48,
  ILLEGAL_CONTENT: 49,
  EMAIL_UNVERIFIED: 50
};

goog.object.extend(exports, proto.no.jotta.openapi);
